module.exports = __webpack_public_path__ + "res/20-img_play_bg.ee982141e9230c66a71067daf1fccbd0.png";